module.exports = __webpack_public_path__ + "img/115.ff8ae391.jpg";